import { Typography } from "@material-ui/core"
import ModelAndDetailing from "./ModelAndDetailing"
import ModelImage from "./ModelImage"

const ModelTitleAndImage = () => (
  <>
    <ModelAndDetailing />
    <ModelImage />
    <Typography variant="srOnly" component={"h2"}>
      גלריית תמונות רכב
    </Typography>
  </>
)

export default ModelTitleAndImage
